import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal, SectionHeading } from "./Reveal";
import { scrollToId } from "@/lib/scroll";
import { IMAGES } from "@/data/site";
import { ProductImage } from "./ProductImage";

export const CategoryNav = ({ onSelectCategory }) => {
  const navigate = useNavigate();
  const go = (cat) => {
    onSelectCategory(cat);
    scrollToId("#katalog");
  };

  const CATS = [
    { id: "saat", label: "Kol Saati", desc: "Erkek & kadın kol saatleri", image: IMAGES.catSaat, testId: "category-saat", span: "md:col-span-7", action: () => go("saat") },
    { id: "taki", label: "Takı", desc: "Bileklik, yüzük & setler", image: IMAGES.catTaki, testId: "category-taki", span: "md:col-span-5", action: () => go("taki") },
    { id: "gozluk", label: "Gözlük", desc: "Güneş gözlüğü koleksiyonu", image: IMAGES.catGozluk, testId: "category-gozluk", span: "md:col-span-5", action: () => go("gozluk") },
    { id: "servis", label: "Teknik Servis", desc: "Bakım, onarım & pil değişimi", image: IMAGES.catServis, testId: "category-servis", span: "md:col-span-7", action: () => navigate("/teknik-servis") },
  ];

  return (
    <section id="kategoriler" data-testid="category-nav-section" className="py-16 md:py-24 lg:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Keşfedin"
          title={<>Kategoriler — <span className="italic text-emerald">dünyamıza göz atın</span></>}
          testId="category-nav"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {CATS.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.08} className={c.span}>
              <button
                onClick={c.action}
                data-testid={c.testId}
                className="group relative block w-full text-left h-64 md:h-72 overflow-hidden bg-emerald cursor-pointer"
              >
                {c.image ? (
                  <div className="absolute inset-y-0 right-0 w-3/5 bg-white">
                    <ProductImage
                      src={c.image}
                      alt={c.label}
                      className="h-full w-full object-contain p-6 transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                  </div>
                ) : (
                  <div className="absolute inset-y-0 right-0 w-3/5 bg-emerald-deep/40 flex items-center justify-center">
                    <p className="font-serif text-xl italic text-ivory/40">Yakında</p>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-r from-emerald-deep via-emerald-deep/80 to-transparent" />
                <div className="relative h-full flex flex-col justify-end p-6 md:p-8">
                  <div className="flex items-center justify-between gap-4">
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ivory/50">0{i + 1}</p>
                      <h3 className="mt-1 font-serif text-3xl md:text-4xl font-semibold text-ivory">{c.label}</h3>
                      <p className="mt-1 text-sm text-ivory/60">{c.desc}</p>
                    </div>
                    <span className="h-11 w-11 shrink-0 rounded-full border border-ivory/30 inline-flex items-center justify-center text-ivory transition-all duration-300 group-hover:bg-ivory group-hover:text-emerald">
                      <ArrowUpRight size={17} />
                    </span>
                  </div>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
